import React from "react";
import {
  CushionTitle,
  Description,
  EnvelopeField,
  Field,
  NeedField,
  Section,
  SectionTitle,
  SmallDescription,
  StyledSectionTitle,
  YamatoEnvelopeImg,
  YamatoTimeImg,
} from "./elements";
import YamatoTime from "../../assets/images/yamato2017_500px.png";
import YamatoEnvelope from "../../assets/images/yamato_envelope.jpg";

export const PickupInstructions: React.FC = React.memo(() => {
  return (
    <Section>
      <StyledSectionTitle>ヤマトの集荷について</StyledSectionTitle>
      <SectionTitle>査定品の発送</SectionTitle>
      <Description>クロネコヤマトの配達員が引き取りに伺います。</Description>
      <Description>
        お申し込み時にご希望の日付、時間を選択いただけます。
      </Description>
      <Description>
        初期化など必要な作業後、緩衝材などに包んだ状態でお持ちください。
      </Description>
      <NeedField>
        <label>ご用意頂くもの</label>
        <SmallDescription>・お売りいただく端末（初期化済）</SmallDescription>
        <SmallDescription>・緩衝材（ご用意頂ける方のみ）</SmallDescription>
        <SmallDescription>
          ※ 梱包資材の中に緩衝材が入っておりますので、必須ではありません。
        </SmallDescription>
      </NeedField>
      <SectionTitle>日付や時間指定が可能！</SectionTitle>
      <Description>お申込みの約1週間後まで指定が可能です。</Description>
      <Description>
        時間指定は、「8～13時」「14～16時」「16～18時」「18～21時」の中からお選びいただけます。
        （「指定なし」も可能です）
      </Description>
      <YamatoTimeImg src={YamatoTime} />
      <Description>
        ※
        査定時に頂いたご希望日時に添えない場合などはメールにてご連絡差し上げますので、お手数ですが再度ご希望日時をご教授ください。
      </Description>
      <Description>
        基本的には査定申込を頂いた翌日の午後以降のお時間をご指定頂きますようお願い申し上げます。
      </Description>
      <SectionTitle>梱包資材</SectionTitle>
      <Description>
        お客様のご希望の査定機種や個数に応じて最適な梱包資材を集荷の際にこちらでご用意させていただきます。
      </Description>
      <CushionTitle>クッション袋（中）</CushionTitle>
      <EnvelopeField>
        <YamatoEnvelopeImg src={YamatoEnvelope} />
        <Field>
          <SmallDescription>クッション袋（中）</SmallDescription>
          <SmallDescription>縦35cm×横24cm</SmallDescription>
        </Field>
      </EnvelopeField>
      <NeedField>
        <SmallDescription>
          基本的にこちらの梱包資材で対応することが多いです。（発送台数が3台未満の場合）
        </SmallDescription>
        <SmallDescription>
          クッション袋の中に緩衝材も入っておりますが、ご不安な方はご自身で緩衝材の同封をお願い致します。
        </SmallDescription>
      </NeedField>
      <CushionTitle>クッション袋（大）</CushionTitle>
      <EnvelopeField>
        <YamatoEnvelopeImg src={YamatoEnvelope} />
        <Field>
          <SmallDescription>クッション袋（大）</SmallDescription>
          <SmallDescription>縦46cm×横32cm</SmallDescription>
        </Field>
      </EnvelopeField>
      <NeedField>
        <SmallDescription>
          査定頂く台数が大口の場合に使用します。（発送台数が5台未満の場合）
        </SmallDescription>
        <SmallDescription>
          クッション袋の中に緩衝材も入っておりますが、ご不安な方はご自身で緩衝材の同封をお願い致します。
        </SmallDescription>
      </NeedField>
      <SectionTitle>注意事項</SectionTitle>
      <Description>古物営業法の住所確認を兼ねております。 </Description>
      <Description>下記内容にご注意ください。</Description>
      <Description>転送不可となります </Description>
      <Description>ご本人様確認書類に記載のご住所のみ可となります </Description>
      <Description>勤務先等への集荷はご利用いただけません</Description>
    </Section>
  );
});

PickupInstructions.displayName = "PickupInstructions";
